<template>
  <div class="book-index-main-link" :style="bookColorTheme">
    <span class="book-index-main-link-chapter-index book-index-chapter-index">
      <slot name="chapterIndex">1 </slot>
    </span>
    <span class="book-index-main-link-text book-index-text-link">
      <slot name="text"> default page </slot>
    </span>
    <span class="book-index-main-link-page-index book-index-page-index"> </span>
  </div>
</template>

<script>
export default {
  name: 'tr-book-index-main-link',
  data: function () {
    return {};
  },
  methods: {},
  computed: {
    correctModuleName() {
      const name = `${this.$store.getters.multibookType
        .charAt(0)
        .toUpperCase()}${this.$store.getters.multibookType.slice(1)}`;

      return name;
    },
    bookColorTheme() {
      return { '--color': this.$store.getters[`${this.correctModuleName}/getBookColorTheme`] };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/bookIndexVariable';
.book-index-main-link {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: $bookIndexMainLinkPadding;
  color: var(--color, $bookIndexChapterColor);
  font-weight: bold;
  cursor: default;
}
</style>
